export const Icon_List = [
  "wrench",
  "wifi",
  "warehouse",
  "vessel-front",
  "user-plus-circle",
  "user-circle",
  "tugboat-side",
  "truck-side",
  "truck-front",
  "tray-arrow-up",
  "tray-arrow-down",
  "trash",
  "train-front",
  "times-circle",
  "times",
  "thumbs-up",
  "thermometer",
  "stop-circle",
  "stop",
  "star",
  "stamp",
  "square-arrow-up-right",
  "snowflake",
  "sliders-horizontal",
  "shrink",
  "share",
  "route",
  "rotate",
  "receipt",
  "quote",
  "question-circle",
  "propellor",
  "printer",
  "previous-circle",
  "previous",
  "plus",
  "play-circle",
  "play",
  "pin",
  "phone-call",
  "phone",
  "person",
  "people",
  "pencil",
  "pause-circle",
  "pause",
  "office-2",
  "office-1",
  "next-circle",
  "next",
  "mouse",
  "minus",
  "microphone",
  "megaphone",
  "man",
  "magnifying-glass",
  "lock-unlocked",
  "lock",
  "link",
  "info-circle",
  "hook-arrow-right",
  "hook-arrow-left",
  "heart",
  "handshake",
  "globe",
  "folder-plus",
  "folder-open",
  "folder-minus",
  "folder-arrow-up",
  "folder-arrow-down",
  "folder",
  "floppy-disk",
  "flame",
  "file-other",
  "file-copy",
  "file-check-stamp",
  "file-check",
  "file-arrows-square",
  "file",
  "eye-slash",
  "eye",
  "expand",
  "exclamation-triangle",
  "exclamation-octagon",
  "exclamation-circle",
  "envelope",
  "ellipsis-vertical",
  "droplet",
  "double-chevron-up",
  "double-chevron-right",
  "double-chevron-left",
  "double-chevron-down",
  "door-arrow-right",
  "dollar-circle",
  "credit-card-front",
  "credit-card-back",
  "container-up",
  "container-tracking",
  "container-tank",
  "container-stacked",
  "container-reefer",
  "container-open-top",
  "container-hook",
  "container-high-cube",
  "container-flat-rack",
  "container-down",
  "container",
  "computer",
  "comments",
  "combined-arrow-up",
  "combined-arrow-right",
  "combined-arrow-left",
  "combined-arrow-down",
  "cog",
  "clock-stopwatch",
  "clock-alarm",
  "clock",
  "clipboard-check-text",
  "clipboard-check",
  "chevrons-up-down",
  "chevrons-left-right",
  "chevron-up",
  "chevron-right",
  "chevron-left",
  "chevron-down",
  "check-circle",
  "check",
  "chart-line-up",
  "chart-bars-vertical",
  "chart-arrow-up-right",
  "caret-up",
  "caret-right",
  "caret-left",
  "caret-down",
  "camera",
  "calendar",
  "browser",
  "box",
  "book-open",
  "bell",
  "bars-horizontal-funnel-left",
  "bars-horizontal-funnel-down",
  "bars-horizontal",
  "arrows-left-right",
  "arrows-down-up",
  "arrow-up-right",
  "arrow-up-left",
  "arrow-up",
  "arrow-to-top",
  "arrow-to-right",
  "arrow-to-left",
  "arrow-to-bottom",
  "arrow-right",
  "arrow-left",
  "arrow-from-top",
  "arrow-from-right",
  "arrow-from-left",
  "arrow-from-bottom",
  "arrow-down-right",
  "arrow-down-left",
  "arrow-down",
  "arrow-curved-up-right",
  "arrow-curved-up-left",
  "arrow-clockwise-times",
  "arrow-clockwise-clock",
  "arrow-clockwise",
  "arrow-anti-clockwise-clock",
  "arrow-anti-clockwise",
  "anchor",
  "airplane",
];
